import LogicTabList from './LogicTabList';
import { LogicTabListProps, LogicTabListValueProps } from './types';

export type { LogicTabListProps, LogicTabListValueProps };
export default LogicTabList;
